import ButtonT from '@components/tailwind-components/Button/ButtonT';
import TextareaT from '@components/tailwind-components/Input/TextareaT';
import type { IntentCheckBlock } from '@conversed/shared/src/central/types/blocks/IntentCheckBlock';
import { useBlocksUpdates } from '@hooks/flow/block/useBlocksUpdates';
import { t } from 'i18next';
import type React from 'react';
import { useCallback } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/modal/useModal';
import { useMainSelector } from '../../../hooks/useMainSelector';

export const IntentCheckInitModal: React.FC<{ block: IntentCheckBlock }> = ({
  block,
}) => {
  const { hideModal } = useModal();
  const { updateBlocks } = useBlocksUpdates();

  const {
    ui: { activeModal },
  } = useMainSelector();

  const onSubmitIntentCheck = useCallback(
    (formData: { intent: string }) => {
      if (formData.intent) {
        updateBlocks([
          {
            ...block,
            params: {
              ...block.params,
              intent: formData.intent,
            },
          },
        ]);
        hideModal();
      }
    },
    [updateBlocks, hideModal, block],
  );

  const { handleSubmit, control } = useForm({
    defaultValues: {
      intent: '',
    },
    shouldUseNativeValidation: true,
  });

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(onSubmitIntentCheck)}
      id={activeModal?.title}>
      <div className='tailwind-modal-body'>
        <Controller
          name='intent'
          control={control}
          rules={{
            required: true,
            validate: (value) => {
              return (
                value.trim().length > 0 ||
                t('flow.blocks.intent-check.intent.validation')
              );
            },
          }}
          render={({ field: { name } }) => {
            return (
              <TextareaT
                field={name}
                control={control}
                placeholder={t('flow.blocks.intent-check.intent.placeholder')}
                className='min-h-[120px] resize-none'
              />
            );
          }}
        />
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
